import { render, staticRenderFns } from "./ItemList.vue?vue&type=template&id=7b49ca32&scoped=true&"
import script from "./ItemList.vue?vue&type=script&lang=ts&"
export * from "./ItemList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b49ca32",
  null
  
)

export default component.exports